import { useEffect } from 'react';
import { useHTTP } from 'hooks/useRequest';
import { requestErrors, inputPrompts } from './approvals_group_text';
import {
  requestTypes,
  approvalRoles,
  groupActions,
} from './approvals_group_reducer';

const useSubmitGroupRequest = (
  nameInput,
  descriptionInput,
  admins,
  approvers,
  users,
  editMode,
  createGroupUrl,
  editGroupUrl,
  request,
  approvalGroupDispatch,
) => {
  const submitGroupRequest =
    request.status && request.type === requestTypes.SUBMIT_GROUP;

  const createRequestPayload = () => {
    if (!submitGroupRequest) return {};
    const groupAdmins = admins
      .filter(admin => admin.selected)
      .map(admin => ({
        customer_id: admin.customer_id,
        role: approvalRoles.ADMIN,
      }));
    const groupApprovers = approvers
      .filter(approver => approver.selected)
      .map(approver => ({
        customer_id: approver.customer_id,
        role: approvalRoles.APPROVER,
      }));
    const groupUsers = users
      .filter(user => user.selected)
      .map(user => ({
        customer_id: user.customer_id,
        role: approvalRoles.USER,
      }));

    const approvalGroupDetails = {
      approval_group: {
        name: nameInput,
        description: descriptionInput,
        approval_group_users_attributes: [
          ...groupAdmins,
          ...groupApprovers,
          ...groupUsers,
        ],
      },
    };
    return JSON.stringify(approvalGroupDetails);
  };

  const requestUrl = editMode ? editGroupUrl : createGroupUrl;

  const submitGroupConfig = {
    method: editMode ? 'put' : 'post',
    url: submitGroupRequest ? requestUrl : null,
    data: createRequestPayload(),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };

  // Send POST request with group data
  const { data: groupHttpData, error: groupHttpError } =
    useHTTP(submitGroupConfig);

  useEffect(() => {
    if (groupHttpError === undefined) return;

    // Show error messages if an error is returned
    if (groupHttpError.error.data.errors.includes(requestErrors.blankName)) {
      approvalGroupDispatch({
        type: groupActions.NAME_INVALID,
        payload: inputPrompts.uniqueName,
      });
      approvalGroupDispatch({
        type: groupActions.DISABLE_REQUEST,
      });
    }

    if (
      groupHttpError.error.data.errors.includes(requestErrors.mustHaveAdmin)
    ) {
      approvalGroupDispatch({
        type: groupActions.ADMINS_INVALID,
        payload: inputPrompts.addGroupAdmin,
      });
      approvalGroupDispatch({
        type: groupActions.DISABLE_REQUEST,
      });
    }
  }, [groupHttpError]);

  useEffect(() => {
    if (groupHttpData === undefined) return;

    if (groupHttpData.success) {
      approvalGroupDispatch({
        type: groupActions.FORM_REDIRECT_URL,
        payload: groupHttpData.redirect_url,
      });
    }
  }, [groupHttpData]);
};

export default useSubmitGroupRequest;
